import React from 'react';

import { Tooltip } from '@/components/Tooltip';

interface ModeIndicatorProps {
  mode: 'query' | 'agent';
  onModeChange: (mode: 'query' | 'agent') => void;
  disabled?: boolean;
}

const ModeIndicator: React.FC<ModeIndicatorProps> = ({
  mode,
  onModeChange,
  disabled = false,
}) => {
  return (
    <Tooltip title={`Switch to ${mode === 'query' ? 'agent' : 'query'} mode`}>
      <button
        type="button"
        onClick={e => {
          e.stopPropagation();
          onModeChange(mode === 'query' ? 'agent' : 'query');
        }}
        disabled={disabled}
        className={`inline-flex flex-shrink-0 items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition-all duration-200 ${
          mode === 'agent'
            ? 'border-chariot-status-high text-chariot-status-high hover:bg-chariot-status-high hover:text-chariot-text-primary'
            : 'border-chariot-brand-primary text-chariot-brand-primary hover:bg-chariot-background-secondary'
        } ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
      >
        <div
          className={`h-1.5 w-1.5 rounded-full ${
            mode === 'agent'
              ? 'bg-chariot-status-high'
              : 'bg-chariot-brand-primary'
          }`}
        />
        <span className="capitalize">{mode}</span>
      </button>
    </Tooltip>
  );
};

export default ModeIndicator;
